export const ACCEPT_HEADER_VALUE_FOR_DOCUMENTS = 'application/json, application/yaml';
export const DEFAULT_BASE_URL = 'https://swagger.io';